import { i18n } from '@/i18n'

export default Validator => {
  Validator.register(
    'slug',
    function(value = '') {
      return /^[a-z0-9](-?[a-z0-9])*$/.test(value)
    },
    i18n.t('invalid', { x: ':attribute' }),
  )
}
